import { VERSION_ROW_TYPES } from '../../../../constants/versionsColumnsObject.js';
import {
  DEFAULT_FONT_SIZE,
  DEFAULT_FONT_WEIGHT,
  EXPANDED_ROW_FONT_SIZE,
  EXPANDED_ROW_FONT_WEIGHT,
} from '../constants.js';

export const mapRowTypeToFontWeight = (type: VERSION_ROW_TYPES) => {
  switch (type) {
    case VERSION_ROW_TYPES.VERSION:
      return EXPANDED_ROW_FONT_WEIGHT;
    case VERSION_ROW_TYPES.CHANNEL:
      return EXPANDED_ROW_FONT_WEIGHT;
    default:
      return DEFAULT_FONT_WEIGHT;
  }
};

export const mapRowTypeToFontSize = (type: VERSION_ROW_TYPES) => {
  switch (type) {
    case VERSION_ROW_TYPES.VERSION:
      return EXPANDED_ROW_FONT_SIZE;
    case VERSION_ROW_TYPES.CHANNEL:
      return EXPANDED_ROW_FONT_SIZE;
    default:
      return DEFAULT_FONT_SIZE;
  }
};
